/*
 * Copyright (c) 2025, Wultra s.r.o. (www.wultra.com).
 *
 * All rights reserved. This source code can be used only for purposes specified
 * by the given license contract signed by the rightful deputy of Wultra s.r.o.
 * This source code can be used only by the owner of the license.
 *
 * Any disputes arising in respect of this agreement (license) shall be brought
 * before the Municipal Court of Prague.
 */

import { cn } from "@/utils/cn"

import AndroidIcon from "../../assets/images/android.svg?react"
import CordovaIcon from "../../assets/images/apache-cordova.svg?react"
import AppleIcon from "../../assets/images/apple.svg?react"
import ReactNativeIcon from "../../assets/images/react-native.svg?react"
import { buttonVariants } from "../primitives/button"
import { Separator } from "../primitives/separator"
import { ApplicationCredentials } from "./application-credentials"
import { ArtifactoryCredentials } from "./artifactory-credentials"

export const GetSdkView = () => {
    return (
        <div className="w-content">
            <h1 className="m-0 mb-3 text-3xl font-bold text-primary">Get the SDK</h1>

            <div className="flex max-w-175 flex-col gap-6">
                <div className="border-2 p-5">
                    <p className="mt-0 mb-2">
                        Visit our developer portal to implement In-App Protection in your mobile application.
                    </p>
                    <a
                        href={devPortalUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={cn(buttonVariants({ size: "sm" }), "uppercase no-underline")}
                    >
                        Developer Portal
                    </a>

                    <Separator className="my-4" />

                    {/*
                     * `role="list"` looks redundant, but Safari drops list semantics from a list
                     * styled `list-style: none` unless the role is explicit.
                     */}
                    <ul role="list" aria-label="Platform SDKs" className="m-0 flex list-none flex-wrap gap-2 p-0">
                        {sdkLinks.map(({ label, url, Icon }) => (
                            <li key={label}>
                                <a
                                    href={url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={cn(
                                        buttonVariants({ variant: "outline", size: "sm" }),
                                        "text-foreground uppercase no-underline"
                                    )}
                                >
                                    <Icon data-icon="inline-start" aria-hidden />
                                    {label}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>

                <ArtifactoryCredentials />
                <ApplicationCredentials />
            </div>
        </div>
    )
}

const devPortalUrl = "https://developers.wultra.com/products/mobile-in-app-protection/"

const sdkLinks = [
    {
        label: "Apple SDK",
        url: "https://developers.wultra.com/components/malwarelytics-apple",
        Icon: AppleIcon
    },
    {
        label: "Android SDK",
        url: "https://developers.wultra.com/components/malwarelytics-android",
        Icon: AndroidIcon
    },
    {
        label: "React Native SDK",
        url: "https://developers.wultra.com/components/react-native-malwarelytics",
        Icon: ReactNativeIcon
    },
    {
        label: "Cordova SDK",
        url: "https://developers.wultra.com/components/malwarelytics-cordova-plugin",
        Icon: CordovaIcon
    }
]
